// extracted by mini-css-extract-plugin
export default {"skeleton-grid":"_koipiy","skeletonGrid":"_koipiy"};